import Route from '@ember/routing/route';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { inject as service } from '@ember/service';
import { COMPANY_CREDIT } from 'sh-www/models/company-credit';

class ReportsCompanyCreditsRoute extends Route {
  @service('commands/cost-code-commands') costCodeCommandService;
  @service session;
  @service store;

  async model() {
    const { company } = this.session.currentUser;

    const creditFactoids = await this.store.query('factoid', {
      type: COMPANY_CREDIT.FACTOID_TYPE,
      filter: {
        company_id: company.id,
      },
    });

    return {
      creditFactoids,
    };
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/reports/company-credits/');
  }

  /**
   * @inheritDoc
   */
  setupController(controller) {
    super.setupController(...arguments);

    if (controller.canViewReport) {
      controller.initializePage();
    }
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    const { isAdmin } = this.session.currentUser;

    if (isExiting) {
      controller.loadCompanyCostCodeCreditsTask.cancelAll({ resetState: true });
      controller.loadCreditPaidInvoicesTask.cancelAll({ resetState: true });
      controller.loadCreditUnpaidInvoicesTask.cancelAll({ resetState: true });

      if (isAdmin) {
        controller.loadCreditDeletedInvoicesTask.cancelAll({ resetState: true });
      }

      controller.setProperties({
        costCodes: [],
        costCodesCurrentPage: 1,
        shGeneralPaidInvoices: [],
        shGeneralUnpaidInvoices: [],
        shGeneralDeletedInvoices: [],
        costCodesCurrentPage: null,
        shGeneralPaidInvoicesPagination: null,
        shGeneralUnpaidInvoicesPagination: null,
        shGeneralDeletedInvoicesPagination: null,
      });
    }
  }
}

export default ReportsCompanyCreditsRoute;
